import ReferencesSection from '../../Sections/ReferencesSection/ReferencesSection';
export default {
	init() {
		ReferencesSection.init();
	},
	finalize() {}
}